<script>
  import relatorioServico from '../relatorio.servico';
  import projetoServico from '~modulos/projeto/servico';

  import 'vue-strap/dist/vue-strap-lang';

  import { radio, datepicker } from 'vue-strap';
  import Sintetico from './Subrubricas/Sintetico.vue';
  import Analitico from './Subrubricas/Analitico.vue';
  import TelaCheia from '~componentes/TelaCheia.vue';
  import CabecalhoRelatorio from '~componentes/CabecalhoRelatorio.vue';

  export default {
    components: { CabecalhoRelatorio, radio, datepicker, Sintetico, Analitico, TelaCheia },
    data() {
      return {
        filtros: {
          idProjeto: '',
          idMetaEtapa: '',
          idConta: '',
          idRubrica: '',
          idSubrubrica: '',
          dataInicio: moment(new Date()).format('DD/MM/YYYY'),
          dataFim: moment(new Date()).format('DD/MM/YYYY'), 
        },
        sintetico: 'true',
        relatorio: {},
        contas: [],
        projetos: [],
        metaEtapas: [],
        rubricas: [],
        subrubricas: [],
        configuracao: this.$storage.configuracao(),
        projeto: null,
        mostrarSinterico: true,
      }
    },
    methods: {
      gerar() {
        this.setarProjeto();
        this.relatorio = {};
        this.mostrarSinterico = (this.sintetico === 'true');

        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");
            
            $('#gerar').button('loading');

            if (this.sintetico === 'true') {
              return relatorioServico.subrubricasSintetico(this.filtros)
            } else {
              return relatorioServico.subrubricasAnalitico(this.filtros)
            }
          })
          .then(resultado => {
            this.relatorio = resultado;
            
            $('#gerar').button('reset');
            
            if (resultado.length === 0) {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              this.$nextTick(() => {
                $('html, body').animate({
                  scrollTop: $('#relatorio').offset().top
                }, 800);
              });
            }
          })
          .catch(erro => {
            $('#gerar').button('reset');

            if (erro.status === 422) {
              this.$mensagemErro(erro, erro.body.message);
            } else {
              this.$mensagemErro(erro, 'Erro ao gerar relatório.');
            }
          });
      },
      gerarExcel() {
        this.setarProjeto();
        this.relatorio = {};
        this.mostrarSinterico = (this.sintetico === 'true');

        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");

            $('#gerar-excel').button('loading');

            return relatorioServico.subrubricasAnaliticoExcel(this.filtros)
          })
          .then(arquivo => {
            $('#gerar-excel').button('reset');

            if (arquivo === '') {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              arquivo.download();
            }
          })
          .catch(erro => {
            $('#gerar-excel').button('reset');

            this.$mensagemErro(erro, 'Erro ao gerar relatório.');
          });
      },
      listaContas(idProjeto) {
        return projetoServico
          .contasProjeto(idProjeto)
          .then(contas => {
            this.contas = contas;
          });
      },
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao("RelSubrubrica")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      listaDeMetaEtapas() {
        return projetoServico
          .metaEtapasProjeto(this.filtros.idProjeto)
          .then(metaEtapas => {
            this.metaEtapas = metaEtapas;
          });
      },
      listaDeRubricas() {
        return projetoServico
          .rubricasProjeto(this.filtros.idProjeto, this.filtros.idMetaEtapa)
          .then(rubricas => {
            this.rubricas = rubricas;
          });
      },
      listaDeSubrubricas() {
        this.filtros.idSubrubrica = '';
        
        if (this.projetoSelecionado.utilizarMetaEtapaProjeto && this.filtros.idMetaEtapa !== '' && this.filtros.idRubrica === '') {
          this.subrubricas = [];
          return;
        }
        
        return projetoServico
          .subrubricasProjeto(this.filtros.idProjeto, this.filtros.idRubrica, this.filtros.idMetaEtapa)
          .then(subrubricas => {
            this.subrubricas = subrubricas;
          });
      },
      setarProjeto() {
        this.projeto = Object.assign({}, this.projetoSelecionado); 
      },
    },
    computed: {
      projetoSelecionado() {
        const idProjeto = this.filtros.idProjeto;
        
        return idProjeto ? this.projetos.find(projeto => projeto.idProjeto == idProjeto) : {};
      },
    },
    mounted() {
      this.$root.tituloDaPagina = `Relatório de Subrubricas`;
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.$events.on('botaoAcao', function() {
        window.print();
      });

      this.listaDeProjetos();

      //$('.datepicker input').attr('readonly', '');

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);
        
        _this.filtros.idMetaEtapa = '';
        _this.filtros.idConta = '';
        _this.filtros.idRubrica = '';
        _this.filtros.idSubrubrica = '';

        if (_this.configuracao.filtrarLancamentoContaCorrenteWeb) {
          _this.listaContas(this.value);
        }
        
        if (_this.projetoSelecionado.utilizarMetaEtapaProjeto) {
          _this.listaDeMetaEtapas();
        }
        
        _this.listaDeRubricas();
        _this.listaDeSubrubricas();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  } 
</script>

<template>
  <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">
    <form class="hidden-print" @submit.prevent="gerar">

      <div class="ibox float-e-margins">
        <div class="ibox-content">

          <div class="row">
            <div class="col-xs-6">
              <div class="form-group">
                <radio
                  v-model="sintetico"
                  selected-value="true"
                  type="success">
                  Sintético
                </radio>
              </div>
            </div>

            <div class="col-xs-6">
              <div class="form-group">
                <radio
                  v-model="sintetico"
                  selected-value="false"
                  type="success">
                  Analítico
                </radio>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group required" :class="{'has-error': errors.has('dataInicio')}">
                <label class="control-label">Período</label>

                <datepicker
                  id="dataInicio"
                  v-mascara="'data-mask'"
                  v-model="filtros.dataInicio"
                  format="dd/MM/yyyy"
                  placeholder="  /  /     "
                  lang="pt-BR">
                </datepicker>

                <p class="text-danger" v-show="errors.has('dataInicio')">{{ errors.first('dataInicio') }}</p>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group" :class="{'has-error': errors.has('dataFim')}">
                <label class="control-label">&nbsp; &nbsp;</label>

                <datepicker
                  id="dataFim"
                  v-mascara="'data-mask'"
                  v-model="filtros.dataFim"
                  format="dd/MM/yyyy"
                  placeholder="  /  /     "
                  lang="pt-BR">
                </datepicker>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group required" :class="{'has-error': errors.has('projeto')}">
                <label class="control-label" for="projeto">Projeto</label>

                <select
                  id="projeto"
                  class="form-control"
                  v-model="filtros.idProjeto"
                  data-vv-name="projeto"
                  v-validate="'required'">
                  <option value="">Selecione...</option>
                  <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                </select>

                <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
              </div>
            </div>
          </div>

          <div class="row" v-if="projetoSelecionado.utilizarMetaEtapaProjeto">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="metaEtapa">Meta Etapa</label>

                <select id="metaEtapa"
                        class="form-control"
                        v-model="filtros.idMetaEtapa"
                        @change="listaDeRubricas(); listaDeSubrubricas();">
                  <option value="">Selecione...</option>
                  <option :value="metaEtapa.idProjetoMetaEtapa" v-for="metaEtapa in metaEtapas">{{ metaEtapa.meta.nome }} {{ metaEtapa.etapa.nome }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row" v-if="configuracao.filtrarLancamentoContaCorrenteWeb">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="conta">Conta</label>

                <select id="conta"
                        class="form-control"
                        v-model="filtros.idConta">
                  <option value="">Selecione...</option>
                  <option :value="conta.idConta" v-for="conta in contas">{{ conta.nomeConta }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="rubrica">Rubrica</label>

                <select id="rubrica"
                        class="form-control"
                        v-model="filtros.idRubrica"
                        @change="listaDeSubrubricas">
                  <option value="">Selecione...</option>
                  <option :value="rubrica.id" v-for="rubrica in rubricas">{{ rubrica.nome }}</option>
                </select>
              </div>
            </div>
          </div>
          
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="subrubrica">Subrubrica</label>

                <select id="subrubrica"
                        class="form-control"
                        v-model="filtros.idSubrubrica">
                  <option value="">Selecione...</option>
                  <option :value="subrubrica.id" v-for="subrubrica in subrubricas">{{ subrubrica.nome }}</option>
                </select>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <button id="gerar"
                    type="button"
                    class="btn btn-primary"
                    @click="gerar"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-line-chart"></i>
              Gerar relatório
            </button>

            <button id="gerar-excel"
                    v-if="sintetico === 'false'"
                    type="button"
                    class="btn btn-primary"
                    @click="gerarExcel"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-table"></i>
              Gerar relatório em excel
            </button>

            <tela-cheia texto="Visualizar em tela cheia"
                        icone="arrows-alt"
                        v-if="Object.keys(relatorio).length !== 0">
            </tela-cheia>
          </div>
        </div>
      </div>
    </form>

    <cabecalho-relatorio titulo="Relatório de Subrubricas" borda=""></cabecalho-relatorio>

    <div class="row" v-if="Object.keys(relatorio).length !== 0" id="relatorio">
      <sintetico 
        :relatorio="relatorio" 
        :configuracao="configuracao" 
        :projeto="projeto"
        :filtros="{ dataInicio: filtros.dataInicio, dataFim: filtros.dataFim }"
        v-if="mostrarSinterico">
      </sintetico>
      <analitico 
        :relatorio="relatorio" 
        :configuracao="configuracao" 
        :projeto="projeto"
        :filtros="{ dataInicio: filtros.dataInicio, dataFim: filtros.dataFim }"
        v-if="!mostrarSinterico">
      </analitico>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/Subrubricas.vue